// SignalR par ek hi string jaati hai.
// Purane messages plain code hain: "1","2","3","4","5","25","35","40","41" (6 kahin aur use hota hai — mat lena).
// Naye messages ko payload chahiye (announcement ka text), isliye format: "50|{json}"
// parseMsg purane plain codes ko bhi waise hi return karta hai, isliye kuch todta nahi.

export const MSG = {
  NOTICE_START: '50',   // Reception -> Display : custom announcement chalu karo
  NOTICE_STOP: '51',    // Reception -> Display : chalu announcement band karo
}

export const packMsg = (code, payload) =>
  (payload === undefined || payload === null) ? String(code) : `${code}|${JSON.stringify(payload)}`

export const parseMsg = (message) => {
  const raw = typeof message === 'string' ? message : String(message ?? '')
  const cut = raw.indexOf('|')
  if (cut === -1) return { code: raw, data: null }
  const code = raw.slice(0, cut)
  try {
    return { code, data: JSON.parse(raw.slice(cut + 1)) }
  } catch (e) {
    return { code, data: null }
  }
}

// notice object ka ek hi shape poore app me
export const makeNotice = ({ text, lang, everyMin, stopAfterMin }) => ({
  id: Date.now(),
  text: String(text || '').trim().slice(0, 300),
  lang: lang === 'en-IN' ? 'en-IN' : 'hi-IN',
  everyMin: Number(everyMin) || 0,        // 0 = ek hi baar
  stopAfterMin: Number(stopAfterMin) || 0, // 0 = jab tak khud band na karein
  startedAt: Date.now(),
})

// repeat wali announcement abhi zinda hai ya time khatam ho gaya
export const isNoticeAlive = (n) => {
  if (!n?.text) return false
  if (!n.everyMin) return false                      // one-time wali refresh ke baad dobara nahi bolni
  if (!n.stopAfterMin) return true
  return Date.now() < (n.startedAt || 0) + n.stopAfterMin * 60000
}

export const noticeLabel = (n) =>
  !n ? '' : n.everyMin
    ? `Every ${n.everyMin} min${n.stopAfterMin ? ` · ${n.stopAfterMin} min tak` : ''}`
    : 'One time'